import React, { PureComponent } from "react";
import { Select, Radio, Checkbox, Button } from "element-react";
import { List, Input } from "antd";
import { Link } from "react-router-dom";
import Navigation from "../../components/navigation";

import Request from "../../networkReq/request";
import Http from "../../networkReq/http"

import add from "../../images/add.png";
import minus from "../../images/minus.png";
import iconLift from "../../images/icon-lift.png";
import iconfy from "../../images/icon-fy.png";
import iconjy from "../../images/icon-jy.png";
import iconby from "../../images/icon-by.png";
import iconty from "../../images/icon-ty.png";
import iconyf from "../../images/icon-yf.png";
import "./index.scss";
import { Message } from "element-react/next";
import { length } from "file-loader";
const { Search } = Input;


export default class Index extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      eventdata: [],
      showChildren: false,
      showid: 0,
      eventChildren: {},
      active: 1,
      citys: [],
      currentname: '',
      currentid: '',
      searchvalue: '',
      flag:false
    };
  }


  componentDidMount() {
    // console.log(this.props.location.state.id);
    const { location: { state } } = this.props;
    Http.get(Request.getServiceManageList(), { current: 1, size: 1000, parentId: 0, hierarchyId: state && state.hierarchyId ? state.hierarchyId : '' }, obj => {
      if (obj.code == 200) {
        console.log(obj);
        this.setState({
          data: obj.data.records,
          currentname: state && state.name ? state.name : obj.data.records[0].serviceName,
          currentid: state && state.id ? state.id : obj.data.records[0].id,
          hierarchyId: state && state.hierarchyId ? state.hierarchyId : ''
        })
        let params = {
          current: 1,
          size: 5,
          parentId: state && state.id ? state.id : obj.data.records[0].id,
          hierarchyId: state && state.hierarchyId ? state.hierarchyId : ''
        };
        this.fetchservices(params);
      }
    });
  }

  handleChildren = (id, state) => {
    const { showChildren, showid, hierarchyId } = this.state;
    let that = this;
    // let eventChildren = that.state.eventChildren;
    let params = {
      current: 1,
      size: 1000,
      serviceId: id,
      itemStatus: 1,
      hierarchyId: hierarchyId,
    };
    // if (state && state == 'all') {
    //   return Http.get(Request.getEvent(), params, obj => {
    //     if (obj.code == 200) {
    //       eventChildren[`${id}`] = JSON.stringify(obj.data.records);
    //       this.setState({
    //         eventChildren: eventChildren,
    //         showChildren: true,
    //         showid: 'all',
    //       })
    //     }
    //   });
    // } else {
    if (showChildren && showid == id) {
      this.setState({
        showChildren: !showChildren,
        showid: id,
      })
    } else if (showChildren && showid != id) {
      // return Http.get(Request.getEvent(), params, obj => {
      //   console.log('obj', obj);
      //   if (obj.code == 200) {
      //     eventChildren[`${id}`] = JSON.stringify(obj.data.records);
      this.setState({
        // eventChildren: eventChildren,
        showid: id,
      })
      //   }
      // });
    } else {
      // return Http.get(Request.getEvent(), params, obj => {
      //   console.log('obj', obj);
      //   if (obj.code == 200) {
      //     eventChildren[`${id}`] = JSON.stringify(obj.data.records);
      this.setState({
        // eventChildren: eventChildren,
        showChildren: !showChildren,
        showid: id,
      })
      //   }
      // });
    }
    // }
  }

  fetchservices = (params) => {
    let that = this;
    return Http.get(Request.getNewHome(), params, obj => {
      if (obj.code == 200) {
        this.setState({
          eventdata: obj.data.records,
          showChildren: true,
          showid: 'all',
        })
      }
    });
    // return Http.get(Request.getHome(), params, obj => {
    //   if (obj.code == 200) {
    //     if (obj.data.records && obj.data.records.length > 0) {
    //       obj.data.records.map(function (r, i) {
    //         that.handleChildren(r.id, 'all');
    //       })
    //     }
    //     this.setState({
    //       eventdata: obj.data.records
    //     })
    //   }
    // });
  }

  handleTabs = (activekey) => {
    this.setState({ active: activekey })
  }

  btnClick(id) {
    this.props.history.push({ pathname: '/entrance/xfapplication', query: { id: id } })
  }

  onlinebtnClick(url) {
    window.open(url);
  }

  handleChange = (item) => {
    const { hierarchyId } = this.state;
    let params = {
      current: 1,
      size: 8,
      parentId: item.id,
      hierarchyId: hierarchyId,
    };
    this.fetchservices(params);
    this.setState({
      currentname: item.serviceName,
      currentid: item.id
    })
  }



  //搜索按钮事件
  onSearch = (e) => {
    const { currentid, searchvalue, hierarchyId } = this.state;
    if (currentid && currentid != '') {
      let params = {
        current: 1,
        size: 8,
        parentId: currentid,
        serviceName: e,
        hierarchyId: hierarchyId,
      };
      this.fetchservices(params);
    }

  }
  //在线办理按钮
  okClick(itemOnlineUrl){
    if(itemOnlineUrl){
      this.onlinebtnClick(itemOnlineUrl)
    }else{
      if(!this.state.flag){
        this.state.flag = true
        Message.error('当前暂不支持在线办理')
        setTimeout(()=>{
          this.state.flag = false
        },3000)
      }
        }
  }


  // throttle(fn,delay=3000){
  //   let preTime = Date.now()
  //   return (event)=>{
  //     const context = this;
  //     event.persist &&event.persist()
  //     let doTime = Date.now()
  //     if(doTime-preTime>=delay){
  //       fn.apply(context)
  //       preTime = Date.now()
  //     }
  //   }
  // }


  render() {
    const { active, data, eventdata, showChildren, eventChildren, showid, currentname, currentid } = this.state;
    console.log('data---', eventdata)
    let arr = [{ id: 1, img: iconLift, name: '入伍' }, { id: 2, img: iconfy, name: '服役' }, { id: 3, img: iconty, name: '退役' }, { id: 4, img: iconjy, name: '就业' }, { id: 5, img: iconyf, name: '优抚' }, { id: 6, img: iconby, name: '褒扬' }];
    return (
      <div className="work-main">
        <Navigation />
        <div className="work-header">
          <div className="work-container">
            <div className="work-title">办事服务</div>
            <div className="work-layout work-tabs">
              <div onClick={() => this.handleTabs(1)} className={`tab ${active == 1 ? "tab-active" : ""} `}>按主题</div>
              {/* <div onClick={() => this.handleTabs(2)} className={`tab ${active==2? "tab-active":""} `}>按生命周期</div> */}
            </div>
          </div>
        </div>
        {active && active == 1 ?
          <div className="work-container">
            <div className="work-layout" style={{ margin: '50px 0px', flexWrap: 'wrap' }}>
              {data && data.length > 0 && data.map((item, i) => {
                return (
                  <div key={i} onClick={() => this.handleChange(item)} className={`work-class ${currentid == item.id ? "isactive" : ""}`}>{item.serviceName}</div>
                )
              })}
            </div>
            <div className="searchOpt">
              <div className="class-title">{currentname}</div>
              <div>
                {/* <Input style={{ width: '385px', height: 35 }} placeholder="输入事项名称关键词" onChange={(e) => this.handleInput(e)} />
                <div onClick={() => this.handleSearch()} className="search">搜索</div> */}

                <Search
                  placeholder="请输入内容"
                  allowClear
                  enterButton="搜索"
                  onSearch={(e) => this.onSearch(e)}
                />
              </div>
            </div>
            <List
              itemLayout="vertical"
              size="large"
              pagination={{
                onChange: page => {
                  console.log(page);
                },
                pageSize: 5,
              }}
              style={{ marginBottom: 15, minHeight: 350 }}
              //, marginTop: 15
              className="elist"
              dataSource={eventdata}
              renderItem={item => (
                <List.Item
                  key={item.id}
                  style={{ padding: 0, paddingBottom: 16, display: 'block', borderBottom: 'none' }}
                // paddingTop: 16, 
                >
                  <div className="listheader" onClick={() => this.handleChildren(item.id)}>
                    {showChildren && (showid == item.id || showid == 'all') ? <img className="icon" src={minus} alt="" /> : <img className="icon" src={add} alt="" />}
                    <span>{item.serviceName}</span>
                  </div>
                  <div style={{ width: '100%', marginBottom: '15px', display: showChildren && (showid == item.id || showid == 'all') ? "block" : "none" }}>
                    <List
                      itemLayout="vertical"
                      size="large"
                      dataSource={item.serviceItemList}
                      renderItem={child => (

                        <List.Item
                          key={child.id}
                          actions={[<Button className="list-button" onClick={this.btnClick.bind(this, child.id)}>办事指南</Button>,
                          <button className={(child.itemOnlineUrl) ? "list-button" : ""} style={{ borderRadius: '7%',width:'96px' ,height:'34px' }} onClick={()=>{
                            this.okClick(child.itemOnlineUrl)}}>在线办理</button>]}
                        >
                          <div className="icon-disc"></div>
                          {child.itemName}
                        </List.Item>
                      )}
                    />
                  </div>
                </List.Item>
              )}
            >
            </List>
          </div> :
          <div className="lift-main">
            <div className="work-container lift-container">
              {arr && arr.length > 0 && arr.map((item, i) => {
                return (
                  <div key={i} className="lift-box">
                    <Link to={{ pathname: 'lifeCycle' }}>
                      <div className="lift-img"><img src={item.img} /></div>
                      <div>{item.name}</div>
                    </Link>
                  </div>
                )
              })}
            </div>
          </div>}
      </div>
    );
  }
}
